<div class="status-bar" aria-hidden="true">
  <span class="carrier">{{ carrierName }}</span>
  <span class="right-icons">
    <span class="signal-bars">
      <span class="bar bar-1"></span>
      <span class="bar bar-2"></span>
      <span class="bar bar-3"></span>
      <span class="bar bar-4"></span>
    </span>
    <span class="battery"><span class="battery-fill"></span></span>
  </span>
</div>
